import { Field } from 'app/interfaces/fields';
import { GlobalService } from './global.service';
import { applyRelationsOnCurrent } from './fieldrelation';
import { Block } from 'app/interfaces/blocks';
import { GeneralPopoverSettingsComponent } from 'app/main/pages/general-editor-tabs/general-popover-settings/general-popover-settings.component';
import { ConditioanlsFeilds } from 'app/main/pages/general-editor-tabs/general-popover-settings/general-popover-settings.dto';


/**
 * collect all the conditioanl fields expect own fields
 * @param contentData 
 * @param globalService 
 * @param generalPopoverSettings 
 */
export function conditioanlsFeilds(contentData:Block, globalService: GlobalService, generalPopoverSettings:GeneralPopoverSettingsComponent) {
    const conditional_fields = [];
    for (const key in globalService.fields_data) {
        if (Object.prototype.hasOwnProperty.call(globalService.fields_data, key)) {
            const field = {...globalService.fields_data[key]};
            const elementExist = document.querySelector('[uuid="' + field.uuid + '"]');
            
            if (Array.isArray(contentData?.fields) && !contentData?.fields.includes(field.uuid) && (elementExist || field?.semi_hidden_field === 1)) {
                if (["1", "2", "3", "4", "6"].includes(field.selected_field)) {
                    const role = generalPopoverSettings.selectRole.find((roles) => roles['id'] == field.selected_for_role_id);
                    field['role_name'] = role ? role['name'] : "";
                    if (["3", "6"].includes(field.selected_field)) {
                        for (const index in field.options) {
                            if (Object.prototype.hasOwnProperty.call(field.options, index)) {
                                const option = field.options[index];
                                conditional_fields.push({ uuid: option.id, name: option.name, role_name: field.role_name, field_name: field.select_type_text, selected_field: field.selected_field, main_uuid: field.uuid, type: field.type });
                            }
                        }
                    } else {
                        conditional_fields.push({ uuid: field.uuid, name: field.select_type_text, role_name: field.role_name, selected_field: field.selected_field, main_uuid: field.uuid, type: field.type });
                    }
                }
            }
        }
    }
    return conditional_fields;
}

/**
 * Select field and apply the relation
 * @param fields 
 * @param currentUuid 
 * @param globalService 
 * @param contentData 
 */
export function selectRelations(fields:ConditioanlsFeilds[], currentUuid:number|string, globalService: GlobalService, contentData:Block) {
    for (const field of fields) {
        const selectedUuid = ['droplist', 'list'].includes(field.type) ? field.main_uuid : field.uuid;
        const selectedField: Field = globalService.fields_data[selectedUuid];
        let linked_conditional_id = selectedField.linked_conditional_id;
        if (typeof linked_conditional_id != 'undefined' && linked_conditional_id.length > 0) {
            linked_conditional_id.push(String(currentUuid))
        } else {
            linked_conditional_id = [String(currentUuid)];
        }
        linked_conditional_id = [...linked_conditional_id, ...(Array.isArray(contentData?.fields) ? contentData.fields : [])];
        globalService.updateField(selectedUuid, { linked_conditional_id: linked_conditional_id });
    }
    if (fields.length == 0) {
        const connectedParentConditionalId = (Array.isArray(contentData?.connected_parent_conditional_id) ? contentData.connected_parent_conditional_id : []);
        for (const field of connectedParentConditionalId) {
            const selectedUuid = ['droplist', 'list'].includes(field.type) ? field.main_uuid : field.uuid;
            const selectedField: Field = globalService.fields_data[selectedUuid];
            let linked_conditional_id = selectedField.linked_conditional_id;
            linked_conditional_id = linked_conditional_id.filter(function (item) { return item != currentUuid; });
            globalService.updateField(selectedUuid, { linked_conditional_id: linked_conditional_id });
        }
    }
    const connected_parent_conditional_id = fields;
    contentData = globalService.updateBlock(currentUuid, { connected_parent_conditional_id: connected_parent_conditional_id });
    applyRelationsOnCurrent(currentUuid, globalService, true);
    for (const field of (Array.isArray(contentData?.fields) ? contentData.fields : [])) {
        const selectedField:Field = globalService.fields_data[field];
        if(selectedField){
            let linked_conditional_id = selectedField.connected_parent_conditional_id;
            if(linked_conditional_id && linked_conditional_id.length){
                linked_conditional_id = [...connected_parent_conditional_id, ...linked_conditional_id];
            } else {
                linked_conditional_id = connected_parent_conditional_id;
            }
            globalService.updateField(field, { connected_parent_conditional_id: linked_conditional_id, enable_conditional: 1 }, () => {
                applyRelationsOnCurrent(field, globalService, true);
            });        
        }

    }
    return contentData;
}